module.exports = __webpack_public_path__ + "static/media/yewu-cj4.829c1750.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageIntelligentDataSecurityGateway/yewu-cj4.png
// module id = 239
// module chunks = 0